import {
  Check,
  Smile,
  Lightbulb,
  Flame,
  Brain
} from "lucide-react";
import Box from '../../components/Box';
import { MarktingCard } from '../../AvatarDigitalMarketer/AiMarketingTeam';
import Text from "../../components/Text";
import Button from "../../components/Button";
import { Img } from "components";

const theHiddenStrugle = [
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "A topper freezes in the exam despite knowing the answers." },
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "A child studies all night, but forgets by morning." },
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Another gives up - not because they can’t, but because they believe they can’t." },
];

const theMordenClassroom = [
  { icon: <Smile className="w-5 h-5 text-[#4949DE]" />, text: "Stress replaces joy" },
  { icon: <Lightbulb className="w-5 h-5 text-[#4949DE]" />, text: "Pressure replaces curiosity" },
  { icon: <Flame className="w-5 h-5 text-[#4949DE]" />, text: "Learning becomes survival" },
  { icon: <Brain className="w-5 h-5 text-[#4949DE]" />, text: "Mindset goes untaught" },
];

const restoringSoulOfLeaning = [
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Daily Mental warm-ups and stories that build optimism" },
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Adaptive tests that remove exam fear" },
  { icon: <Check className="w-4 h-4 text-[#4949DE]" />, text: "Parent helpdesk with evidence-based advice" },
];

const thePsychology = [
  { icon: "", text: "Growth Mindset (Dweck)" },
  { icon: "", text: "Social Learning (Bandura)" },
  { icon: "", text: "Emotional Intelligence (Goleman)" },
  { icon: "", text: "Child Development (Piaget & Erikson)" },
];

const learningMembers = [
  {
    title: "The Hidden Struggle",
    description: "Children face competition, comparison, and invisible pressure. They’re expected to master subjects and themselves — time, stress, focus, collaboration, motivation. Textbooks can’t solve fear, distraction, anxiety, and self‑doubt alone.",
    footer: <div className="space-y-3">
      {theHiddenStrugle.map((section, index) => (
        <div key={"f" + index} className="flex items-center gap-3">
          {!!section.icon && section.icon}
          <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        </div>
      ))}
    </div>
  },
  {
    title: "Modern Classroom Dilemma",
    description: "Social pressure, emotional fatigue, performance anxiety, digital overload — every day. Marks don’t decide success anymore; mindset does. Yet systems still reward memory over mental strength.",
    footer: <div className="grid grid-cols-2 md:grid-cols-1 gap-4">
      {theMordenClassroom.map((section, index) => (
        <div key={"m" + index} className="flex items-center gap-3 border border-[#E2E8F1] rounded-lg p-2">
          {!!section.icon && section.icon}
          <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        </div>
      ))}
    </div>
  },
  {
    title: "Soomuch.AI : Restoring the Soul of Learning",
    description: "We bring AI teachers that build emotional strength and resilience. They work alongside your staff to create calm, confident learners - daily, automatically.",
    footer: <div className="space-y-3">
      {restoringSoulOfLeaning.map((section, index) => (
        <div key={"fa" + index} className="flex items-center gap-3">
          {!!section.icon && section.icon}
          <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        </div>
      ))}
      <div className="mt-8 flex items-center gap-6 md:flex-col md:justify-center">
        <Button label='Book Live Demo' type='gradient' />
        <Button label="Claim ₹5 Lakh Free Access" type='outlined' />
      </div>
    </div>
  },
  {
    title: "The Psychology We Use",
    description: "Our AI follows Proven research from top Psychologists to create daily learning routines that build mindset and emotional skills.",
    footer: <div className="grid grid-cols-2 gap-4">
      {thePsychology.map((section, index) => (
        <div key={"mk" + index}>
          <Text label={section.text} cName="text-gray-700 text-xs font-semibold leading-relaxed" />
        </div>
      ))}
    </div>
  }
];

export default function SoulOfTeaching() {

  return (
    <>
      <Box
        badge={"WHY YOU NEED US"}
        title={"The Soul of Teaching"}
        description={"A short intro to the problem and the emotional tone. The full content is built for long-form storytelling that inspires school leaders to act."}
        leftBlock={
          learningMembers.slice(0, 2).map((member, index) => <MarktingCard key={"memberUpperCardIN" + index} member={member} />)
        }
        rightBlock={learningMembers.slice(2).map((member, index) => (learningMembers.slice(2)?.length === index + 1) ? <div className="flex flex-col justify-between gap-4">
          <MarktingCard key={"memberUpperCardIN" + index} member={member} />
          <div className="flex justify-center">
            <Img
              alt={"psycology"}
              src={`images/new-landing-page/psycology.png`}
              className="object-cover w-[90%] h-full"
            />
          </div>
        </div> : <MarktingCard key={"memberUpperCardIN" + index} member={member} />)}
      />

    </>
  );
}